import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'wz-wrapper',
  template: `
    <div class="card">
      <div class="card-body">
        <p>
          Il s’agit d’une vente à distance faisant l’objet d’un appel
          téléphonique non sollicité
          <strong
            >qui doit être effectuée en « deux temps », soit après un second
            appel qui aura lieu au moins 24 heures après le 1er appel </strong
          >et la réception par le prospect des informations précontractuelles
          transmises sur support durable par courriel à son adresse électronique
        </p>
        <ng-container #fieldComponent></ng-container>
      </div>
    </div>
  `,
  standalone: false,
})
export class WrapperComponent extends FieldWrapper {}
